module.exports = __webpack_public_path__ + "static/media/play.0afc49f2.svg";